import {catchError, map, Observable, of} from 'rxjs';
import {
  CreateEventPayload,
  ErrorMsg,
  MeetingRoomApi,
  MeetingRoomEvent,
  MeetingRoomStatusesResponse,
  ProcessedStatusesMeetingRoom,
} from './meetingroom-api.types';
import {
  GlobalContainerTypes,
  Http,
  inject,
  injectable,
  MeetingRoomNormalizationService,
  MeetingRoomProcessedStatus,
  ProcessedMeetingRoomEvent,
} from '../..';
import {isEmpty} from 'lodash';
import {getIanaTimeZone} from '@shared/utilities';

@injectable()
class MeetingRoomApiService implements MeetingRoomApi {
  public static readonly type = GlobalContainerTypes.MeetingRoomApi;

  @inject(GlobalContainerTypes.Http) private http: Http;
  @inject(GlobalContainerTypes.MeetingRoomNormalization)
  private meetingRoomNormalizationService: MeetingRoomNormalizationService;

  public createMeetingRoomEvent(payload: CreateEventPayload): Observable<MeetingRoomEvent | ErrorMsg> {
    return this.http
      .POST<MeetingRoomEvent | ErrorMsg>('/meetingroom/events/', payload)
      .pipe(catchError((error) => of({payload: error?.response?.data, statusErr: error?.response?.status})));
  }

  public getMeetingRoomStatuses(floorId?: string): Observable<ProcessedStatusesMeetingRoom> {
    const params = new URLSearchParams('');
    if (floorId) {
      params.append('floor_id', floorId);
    }
    return this.http.GET<MeetingRoomStatusesResponse>('/meetingroom/statuses/', {params}).pipe(
      catchError(() => of({})),
      map((data) => {
        if (isEmpty(data)) return {};

        return Object.fromEntries(
          Object.entries(data).map(([key, value]) => {
            const modifiedKey = key.split('@')[0];
            return [
              modifiedKey,
              this.meetingRoomNormalizationService.normalizeMeetingRoomStatus(value) as MeetingRoomProcessedStatus,
            ];
          }),
        );
      }),
    );
  }

  public getMeetingRoomEvents(date: string, meetingRoomId: string): Observable<ProcessedMeetingRoomEvent[]> {
    const params = new URLSearchParams('');
    const timezone = getIanaTimeZone();
    params.append('start_date', date);
    params.append('time_zone', timezone);

    return this.http.GET<MeetingRoomEvent[]>(`/meetingroom/${meetingRoomId}/events/?${params}`).pipe(
      catchError(() => of([])),
      map(this.meetingRoomNormalizationService.normalizeMeetingRoomEvents),
    );
  }
}

export default MeetingRoomApiService;
